import React from "react";
import { FaPlane, FaWarehouse } from "react-icons/fa";
import { VscNewFile, VscSaveAs } from "react-icons/vsc";
import { Row, Col, Card, Spinner, Placeholder, Button, Badge, Form } from "react-bootstrap";

class _waitParts extends React.Component {

    state = {
        parts: [],
        filter: "",
    }

    _filter = (data) => {
        let filterData = data;
        if (filterData) {
            if (this.state.filter.length > 0) {
                const fulltext = JSON.stringify(filterData);
                return fulltext.toUpperCase().indexOf(this.state.filter.toUpperCase()) > -1
            } else {
                return filterData;
            }

        }
    }

    componentDidMount() {
        this.setState({ parts: this.props.waitParts })
    }

    render() {
        return (
            <>
                <Row className="mb-4">
                    <Col>
                        <Card bg="uni">
                            <Card.Body>
                                <Row>
                                    <Col className="d-flex justify-content-between align-items-center">
                                        <span><strong>Parametry hledání</strong></span>
                                        <Col xs={6} md={4}>
                                            <Form.Control value={this.state.filter} onChange={(e) => this.setState({ filter: e.target.value })} placeholder="...filtrovat" />
                                        </Col>

                                    </Col>
                                </Row>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row className="mb-2">
                    <Col>
                        <Card bg="uni">
                            <Card.Body>
                                <Row>
                                    <Col className="d-flex justify-content-between align-items-center">
                                        <span><strong>Vybrané</strong></span>
                                        <span>
                                            <Button data-tip="Přidat do objednávky" variant="light"><VscNewFile className="fs-20 " /></Button>
                                            <Button data-tip="Uložit" variant="light"><VscSaveAs className="fs-20 " /></Button>
                                        </span>
                                    </Col>
                                </Row>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                {this.state.parts.filter(this._filter).map((e, idx) => (
                    <Row className="mb-2">
                        <Col>
                            <Card bg={!e.matPO ? "uni" : "white"}>
                                <Card.Body>
                                    <Row>
                                        <Col xs={1} className="d-flex justify-content-between align-items-center">
                                        <span>
                                                <Form.Check checked={!e.matPO} />
                                            </span>
                                        </Col>
                                        <Col className="d-flex justify-content-between align-items-center">
                                            
                                            <Row>
                                                <Col xs={12}><span><strong>{e.matItemCode}</strong></span></Col>
                                                <Col xs={12}><small>{e.ItemName}</small></Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12}><span>{e.docNo}</span></Col>
                                                <Col xs={12}>
                                                    <span>{e.TrNo}</span>
                                                </Col>
                                            </Row>
                                            <Col xs={6} md={4}>
                                                <Form.Control disabled type="number" max={9999999999} min={1000000000} isInvalid={!e.matPO} isValid={e.matPO} value={e.matPO} onChange={(e) => this.props.setState({ waitParts: { matPO: e.target.value } })} placeholder="" />
                                                <Form.Text>Číslo dopravy</Form.Text>
                                            </Col>
                                            <Col xs={6} md={4}>
                                                <Form.Control disabled type="number" max={1000} min={9999} isInvalid={!e.matPO} isValid={e.matPO} value={e.matPO} onChange={(e) => this.props.setState({ waitParts: { matPO: e.target.value } })} placeholder="" />
                                                <Form.Text>Sales Org.</Form.Text>
                                            </Col>

                                        </Col>
                                    </Row>

                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                ))}
            </>
        )
    }
}
export default _waitParts;